import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { LMEXPRESS_TYPE } from 'constants/config'
import Mask from 'vanilla-masker'

class LmExpressViewContent extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    titleText: PropTypes.string.isRequired,
    subText: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    subtitle: PropTypes.string.isRequired,
    titleList: PropTypes.string.isRequired,
    listSections: PropTypes.array.isRequired,
    typeContent: PropTypes.number.isRequired,
  }

  state = {
    percent: '',
    currency: '',
    sizeCurrency: '',
    formatCurrency: {
      separator: '',
      delimiter: '',
    },
  }

  componentDidMount() {
    const { translate } = this.props

    this.setState({
      percent: translate('option.percent'),
      currency: translate('option.currency'),
      sizeCurrency: translate('size.currency'),
      formatCurrency: {
        separator: translate('separator.currency'),
        delimiter: translate('delimiter.currency'),
      },
    })
  }

  renderSector = (sector, index) => {
    const { typeContent, translate } = this.props

    let percent = false
    let value1 = ''
    let value2 = ''

    const nexHour = sector.initialHour + 1

    switch (typeContent) {
      case LMEXPRESS_TYPE.CLIENTS:
        value1 = `${sector.initialHour}:00 - ${nexHour}:00`
        value2 = sector.quantity + translate('lmexpress.clientsAttended')
        break
      case LMEXPRESS_TYPE.LMS:
        value1 = `${sector.lm} - ${sector.name}`
        value2 = `${sector.sectionId} - ${sector.sectionDescription}`
        percent = sector.percent || 0
        percent =
          Mask.toMoney(
            percent ? percent.toFixed(this.state.sizeCurrency) : 0,
            this.state.formatCurrency
          ) + this.state.percent
        break
      case LMEXPRESS_TYPE.SECTIONS:
        value1 = `${sector.sectionId} - ${sector.sectionDescription}`
        value2 = sector.quantity
        percent = sector.percent || 0
        percent =
          Mask.toMoney(
            percent ? percent.toFixed(this.state.sizeCurrency) : 0,
            this.state.formatCurrency
          ) + this.state.percent
        break
      default:
        break
    }

    return (
      <tr key={index}>
        <td>{value1}</td>
        <td className='align-right'>{value2}</td>
        <td className='align-right'>{percent}</td>
      </tr>
    )
  }

  render() {
    const {
      titleText,
      subText,
      value,
      subtitle,
      titleList,
      listSections,
      translate,
      typeContent,
    } = this.props

    let dataLabel = ''
    let valueLabel = ''
    let percentLabel = false

    switch (typeContent) {
      case LMEXPRESS_TYPE.CLIENTS:
        dataLabel = translate('lmexpress.officeHours')
        valueLabel = translate('lmexpress.numberClients')
        percentLabel = { percentLabel }
        break
      case LMEXPRESS_TYPE.LMS:
        dataLabel = translate('lmexpress.lm')
        valueLabel = translate('lmexpress.section')
        percentLabel = this.state.percent
        break
      case LMEXPRESS_TYPE.SECTIONS:
        dataLabel = translate('lmexpress.section')
        valueLabel = translate('lmexpress.lmQuantity')
        percentLabel = this.state.percent
        break
      default:
        break
    }

    return (
      <div className='rectangle no-margin rounded'>
        <h4 className='heading-4 uppercase title'>{titleText}</h4>
        <div>
          <span className='highlighted-number'>{value}</span>
          <span className='subtext'>{subText}</span>
          <br />
        </div>
        <p className='text'>{subtitle}</p>
        <p className='text bold'>{titleList}</p>

        <table className='table table-striped'>
          <thead>
            <tr>
              <th>{dataLabel}</th>
              <th className='align-right'>{valueLabel}</th>
              {percentLabel && <th className='align-right'>{percentLabel}</th>}
            </tr>
          </thead>
          <tbody>
            {listSections ? listSections.map(this.renderSector) : ''}
          </tbody>
        </table>
      </div>
    )
  }
}

export default LmExpressViewContent

export { LmExpressViewContent }
